import { render, staticRenderFns } from "./ApiMethodDocument.vue?vue&type=template&id=63608bb8&scoped=true&"
import script from "./ApiMethodDocument.vue?vue&type=script&lang=js&"
export * from "./ApiMethodDocument.vue?vue&type=script&lang=js&"
import style0 from "./ApiMethodDocument.vue?vue&type=style&index=0&id=63608bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63608bb8",
  null
  
)

export default component.exports